import { ProcessorJobStageTaskStatus, StatusVariant } from '@consigli/types';

export const taskStatusMapping = {
  [ProcessorJobStageTaskStatus.INITIALIZED]: { text: 'Initialized', variant: StatusVariant.INFO },
  [ProcessorJobStageTaskStatus.STARTED]: { text: 'Started', variant: StatusVariant.INFO },
  [ProcessorJobStageTaskStatus.FAILED]: { text: 'Failed', variant: StatusVariant.ERROR },
  [ProcessorJobStageTaskStatus.COMPLETED]: { text: 'Completed', variant: StatusVariant.SUCCESS },
  [ProcessorJobStageTaskStatus.SKIPPED]: { text: 'Skipped', variant: StatusVariant.WARNING },
} as const;
